import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, userinfoActions } from '../../../store/actions'
import Input from '../../../module/input/CustomInput'
import { valid } from '../../../hook/valid'
import validPassword from '../../../hook/valid/password'
import moment from 'moment'
// import {bcrypt} from "bcryptjs";

const ChangePass = (props) => {
  const [pass, setPass] = useState()
  const [state, setState] = useState({
    passwd: '',
    tmpNewPwd: '',
    checPwd: '',
    errMessage: '',
  })

  useEffect(() => {
    props.load()
  }, [])

  useEffect(() => {
    setState({ ...state, memberId: props.userInfo?.memberId })
  }, [props.userInfo])

  // 처음 화면 loading 후 비밀번호 초기화시킴 - 이외 사용자정보만 들고있음
  useEffect(() => {
    if (props.isSearch) {
      setState(props.userInfo)
    }
  }, [props.isSearch])

  useEffect(() => {
    if (props.isUpdatePass) {
      props.success({
        title: '변경성공',
        message: '성공적으로 변경되었습니다. 다시 로그인해주세요.',
        params: {
          type: 'success',
          action: 'authActions',
          method: 'logOut',
          params: '/loginIntro',
        },
      })
    } else {
      setPass('')
    }
  }, [props.isUpdatePass])

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'passwd') {
      setPass(value)
    } else {
      setState({
        ...state,
        [name]: value,
      })
    }
  }

  // 저장 버튼 클릭
  const handleSubmit = (e) => {
    e.preventDefault()

    let chkObj = {
      pass: pass,
      tmpNewPwd: state.tmpNewPwd,
      errMessage: state.errMessage,
    }

    // 유효성 체크
    if (props.checkFindInput(chkObj)) {
      let sendObj = {
        userId: state.memberId,
        passwd: pass,
        newPassword: state.tmpNewPwd,
        newPasswordConfirm: state.checPwd,
      }

      props.updatePass(sendObj)
    }
  }

  useEffect(() => {
    if (state.tmpNewPwd !== state.checPwd) {
      // 동일하지 않은 경우
      state.isEqual = false
      state.errMessage = '비밀번호가 동일하지 않습니다.'
    } else {
      // 동일한 경우
      state.isEqual = true
      state.errMessage = validPassword({ password: state.tmpNewPwd, id: state.memberId })
    }

    setState({
      ...state,
      isShow: true,
    })
  }, [state.tmpNewPwd, state.checPwd])

  return (
    <div id="contents">
      <div className="content-header">
        {/* mobile 뒤로가기 버튼 */}
        <a
          onClick={(e) => {
            e.preventDefault()
            window.history.back()
          }}
          className="page-prev"
        >
          뒤로이동
        </a>
        <h2>비밀번호 변경</h2>
        <div className="breadcrumb">
          <span>Home</span>
          <span>마이페이지</span>
          <em>비밀번호 변경</em>
        </div>
      </div>
      <div className="guide-box">
        <dl className="dlist1">
          <dt>이용안내</dt>
          <dd>영문, 숫자, 특수문자 중 2종류를 조합 10~16자 (3종류 8~16자리)로 구성할 수 있습니다.</dd>
          <dd>동일번호 및 연속번호는 등록이 불가합니다.</dd>
          {/* <dd>변경일로부터 3개월까지만 유지되며, 이후에 다시 변경해야 합니다.</dd> */}
          <dd>비밀번호에 아이디를 포함할 수 없습니다.</dd>
          <dd>변경 비밀번호와 기존 비밀번호가 동일한 경우, 등록이 불가합니다.</dd>
          <dd>
            <strong>3개월마다 새로운 비밀번호로 안전하게 관리하세요.</strong>
          </dd>
        </dl>
      </div>
      <p className="required mt30">* 표시는 필수 입력사항입니다.</p>
      <table className="tbl-write">
        <caption>아이디, 현재 비밀번호, 새 비밀번호, 새 비밀번호 확인 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 아이디
            </th>
            <td>
              <span className="inquiry-group">
                {/* <input type="text" defaultValue="abcd0123" readOnly="" /> */}
                <Input
                  inputTitle="아이디"
                  type={'text'}
                  id="memberId"
                  name="memberId"
                  value={state.memberId || ''}
                  required={true}
                  readOnly={true}
                  flow={'right'}
                  wrapperClassWidth="inherit"
                />
              </span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 현재 비밀번호
            </th>
            <td>
              {/* <input type="password" placeholder="현재 비밀번호를 입력하세요." className="form-keyword" /> */}
              <Input
                inputTitle="현재 비밀번호"
                type="password"
                id="passwd"
                name="passwd"
                value={pass || ''}
                className="form-keyword"
                placeholder="현재 비밀번호"
                onChange={(e) => handleChange(e)}
              />
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 새 비밀번호
            </th>
            <td>
              {/* <input type="password" placeholder="새 비밀번호를 입력하세요." className="form-keyword" /> */}
              <Input
                inputTitle="새 비밀번호"
                type="password"
                id="tmpNewPwd"
                name="tmpNewPwd"
                className="form-keyword"
                value={state.tmpNewPwd || ''}
                placeholder="새 비밀번호"
                required={true}
                numberOnly={false}
                flow="left"
                onChange={(e) => handleChange(e)}
              />
              <p className="desc">
                ※ 영문, 숫자, 특수문자 중 2종류를 조합 10~16자 (3종류 8~16자리)로 설정
                {/* <br /> ※ 특수문자는 숫자 키보드 위의 [!@#$%^&amp;*_+{'}'}만 가능 */}
              </p>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 새 비밀번호 확인
            </th>
            <td>
              {/* <input type="password" placeholder="새 비밀번호를 다시 입력하세요." className="form-keyword" /> */}
              <Input
                inputTitle="새 비밀번호 확인"
                type="password"
                id="checPwd"
                name="checPwd"
                className="form-keyword"
                value={state.checPwd || ''}
                placeholder="새 비밀번호 확인"
                required={true}
                okMessage={state.isShow && state.isEqual && !state.errMessage && state.checPwd ? '동일한 비밀번호입니다.' : ''}
                errMessage={state.isShow && state.errMessage ? state.errMessage : ''}
                numberOnly={false}
                flow="left"
                onChange={(e) => handleChange(e)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <p className="mt5">＊최신 수정일 : {props.userInfo?.passwdModDt ? moment(props.userInfo?.passwdModDt).format('YYYY.MM.DD') : ''}</p>
      <div className="btn-block mt0">
        <span className="right">
          <a href="#" className="btn-secondary md" onClick={() => window.history.back()}>
            취소
          </a>
          <a href="#" className="btn-primary md" onClick={(e) => handleSubmit(e)}>
            저장
          </a>
        </span>
      </div>
      {/* <Alert /> */}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    isSearch: state.userinfo?.isSearch,
    isUpdatePass: state.userinfo?.isUpdatePass,
    userInfo: state.userinfo?.data,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  checkFindInput: valid.checkFindInput,
  success: alertActions.success,
  updatePass: userinfoActions.updatePass,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(ChangePass)
